import {api} from "../../services";
import Swal from "sweetalert2";

const tickets = {
  state: {
    creating_new_ticket: false,
    histories_followup_ticket: [],
    pagination: [],
    tickets_report_pagination: [],
    data: [],
    tickets_lead: [],
    ticket: {},
    infos: {
      status_waiting: null,
      status_in_operator: null,
      status_closed: null,
      status_rejected: null,
      total: null
    },
    ticket_view: 1,
    ticket_step: 0,
    search_ticket: {
      status_key: null,
      channel_id: null,
      source_id: null,
      department_id: null,
      operator_id: null,
      funnel_id: null,
      interest_id: null,
      motive_id: null,
      protocol: '',
      lead_name: '',
      lead_phone: '',
      per_page: 10,
    },
    ticket_transfer: {
      operator_id: null,
      department_id: null,
      channel_id: null,
    },
    funnels: {
      data: [],
      search: {
        channel_id: null,
        department_id: null,
        operator_id: null
      }
    },
    ticket_statuses: [],
    filter_tickets_active: false
  },
  getters: {
    getTicketObject: (state) => (key, value) => {
      const object = state.data.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getTicketsArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
  },
  mutations: {
    SET_TICKETS(state, payload) {
      //dependencies
      // this.dispatch("getLeadsData", payload.data.map(item => item.lead_id));
      state.pagination = payload
      this.dispatch("getLeadsData", payload.data);
    },
    // Tickets Report
    SET_TICKETS_REPORT(state, payload) {
      //dependencies
      // this.dispatch("getLeadsData", payload.data.map(item => item.lead_id));
      state.tickets_report_pagination = payload
      if (window.route.name === 'ReportsTickets') {
        this.dispatch("getLeadsData", payload.data);
      }
    },
    // Tickets Report
    SET_TICKETS_DATA_REPORT(state, payload) {
      //dependencies
      // this.dispatch("getLeadsData", payload.map(item => item.lead_id));
      payload.forEach(p => {
        const exist = state.data.find(e => {
          return e.id === p.id;
        });
        if (!exist) {
          state.data.push(p);
        }
      });
      if (window.route.name === 'ReportsTickets') {
        this.dispatch("getLeadsData", payload.data);
      }
    },
    SET_TICKETS_LEAD(state, payload) {
      state.tickets_lead = payload
    },
    SET_TICKETS_DATA(state, payload) {
      //dependencies
      // this.dispatch("getLeadsData", payload.map(item => item.lead_id));
      payload.forEach(p => {
        const exist = state.data.find(e => {
          return e.id === p.id;
        });
        if (!exist) {
          state.data.push(p);
        }
      });
      if (window.route.name === 'ReportsHsm' || window.route.name === 'ReportsWebhooks') {
        this.dispatch("getLeadsData", payload);
      }
    },
    SET_TICKET(state, payload) {
      this.dispatch("getHistoriesData", payload.id);
      // TODO: Tratamento paliativo para quando o objeto 'negotiation' estiver nulo.
      if (payload.negotiation === null) {
        payload.negotiation = {
          amount: "R$ 0,00",
          status_key: 0,
          text: null,
        }
      }
      state.ticket = payload
    },
    SET_TICKET_STATUSES(state, payload) {
      state.ticket_statuses = payload
    },
    SET_TICKETS_KANBAN(state, payload) {
      state.funnels.data = payload
      // this.dispatch("getLeadsData", payload);
    },
    SET_TICKET_STEP(state, payload) {
      state.ticket_step = payload
    },
    SET_TICKETS_INFOS(state, payload) {
      state.infos = payload
    },
  },
  actions: {
    getTickets(context, payload = {}) {
      api.get('/tickets', {
        params: payload
      }).then(response => {
        context.commit("SET_TICKETS", response.data);
        context.commit("SET_TICKETS_DATA", response.data.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getTicketsReport(context, payload = {}) {
      api.get('/tickets', {
        params: payload
      }).then(response => {
        context.commit("SET_TICKETS_REPORT", response.data);
        context.commit("SET_TICKETS_DATA_REPORT", response.data.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getTicketsLead(context, payload = {}) {
      api.get('/tickets', {
        params: payload
      }).then(response => {
        context.commit("SET_TICKETS_LEAD", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getTicketsData(context, payload) {
      if (payload !== undefined) {
        let ids = [];
        payload.forEach(item => {
          const tickets = context.state.data.find(ticket => {
            return item.ticket_id === ticket.id
          });
          if (tickets === undefined) {
            ids.push(item.ticket_id);
          }
        });
        if (ids.length > 0) {
          api.post(`/tickets/data`, {ids}).then(response => {
            context.commit("SET_TICKETS_DATA", response.data);
          }).catch(error => {
            if (error.response.status === 401) {
              this.dispatch('logoutUser');
            }
          });
        }
      }
    },
    updateTicket(context, payload) {
      api.put(`/tickets/${payload.id}`, payload).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_933'),
          showConfirmButton: false,
          timer: 800
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Export Tickets
    exportCsvHistories(context, payload = {}) {
      api.post('/tickets/download/pdfs', payload).then((response) => {
        // if(response.data && response.data.message && response.data.message == 'exporting') {
        //   Swal.fire({
        //     position: 'center',
        //     icon: 'info',
        //     // text: context.rootGetters.getTranslations('expression_913'),
        //     title: 'Já existe um Relatório de Históricos sendo processado, por favor aguarde!',
        //     showConfirmButton: true
        //   })
        // } else {
        //   Swal.fire(
        //     `${context.rootGetters.getTranslations('expression_951')}`,
        //     `${context.rootGetters.getTranslations('expression_952')}`,
        //     'success'
        //   )
        // }
        Swal.fire(
          `${context.rootGetters.getTranslations('expression_951')}`,
          `${context.rootGetters.getTranslations('expression_952')}`,
          'success'
        )
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Export Tickets Excel
    exportExcelTickets(context, payload = {}) {
      api.post('/tickets/download/excel', payload).then((response) => {
        if(response.data && response.data.message && response.data.message == 'exporting') {
          Swal.fire({
            position: 'center',
            icon: 'info',
            // text: context.rootGetters.getTranslations('expression_913'),
            title: 'Já existe um Relatório de Tickets sendo processado, por favor aguarde!',
            showConfirmButton: true
          })
        } else {
          Swal.fire(
            `${context.rootGetters.getTranslations('expression_951')}`,
            `${context.rootGetters.getTranslations('expression_952')}`,
            'success'
          )
        }
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    ticketTransferAdmin(context, payload) {
      api.post(`/chat/ticket/transfer`, payload).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_913'),
          showConfirmButton: false,
          timer: 1000
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    ticketKanban(context, payload) {
      api.post(`/tickets/kanban`, payload).then((response) => {
        context.commit("SET_TICKETS_KANBAN", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Cards Info
    getTicketsInfo(context, payload = {}) {
      api.get('/tickets/info', {
        params: payload
      }).then(response => {
        context.commit("SET_TICKETS_INFOS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Statuses
    getTicketStatuses(context, payload = {}) {
      api.get('/ticket_status', {
        params: payload
      }).then(response => {
        context.commit("SET_TICKET_STATUSES", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  },
}
export default tickets;
